// eslint-disable-next-line import/prefer-default-export
export const BACKEND_BASE_URL = (process.env.REACT_APP_PROJECT_MODE==="production")?process.env.REACT_APP_BACKEND_PROD_URL:(process.env.REACT_APP_PROJECT_MODE==="stage")?process.env.REACT_APP_BACKEND_STAGE_URL:process.env.REACT_APP_BACKEND_DEV_URL;
